/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ChecklistMultiChoiceConfig } from './checklist-multi-choice-config';
import { FreeTextConfig } from './free-text-config';
import { PhotoUploadConfig } from './photo-upload-config';

export class CustomStepConfig {
  prompt: string;
  multiChoiceConfig: ChecklistMultiChoiceConfig;
  freeTextConfig: FreeTextConfig;
  photoUploadConfig: PhotoUploadConfig;
  ancillaryStepName: string;
}
